module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery1.5b561cb802f7c62a30ae1aaa64ac98bb.png";